import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserLeaveBalance } from './firebase';
import { STATUS_FETCHING, STATUS_ERROR, STATUS_READY, STATUS_IDLE } from './constants';

export const fetchLeaveBalanceByNip = createAsyncThunk(
  'getUserLeaveBalance',
  async (nip) => await getUserLeaveBalance(nip)
);

const userLeaveBalanceSlice = createSlice({
  name: 'userLeaveBalance',
  initialState: {
    status: STATUS_IDLE,
    data: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLeaveBalanceByNip.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchLeaveBalanceByNip.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchLeaveBalanceByNip.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default userLeaveBalanceSlice.reducer;
